import { useNavigate } from "react-router-dom";
import axios from 'axios';
import CryptoJS from 'crypto-js';
// import useDecryptedAuth from "./useDecryptedAuth";

const useRequests = () => {
    const navigate = useNavigate();
    // const decryptedAuth = useDecryptedAuth();
    const TokenDetails = JSON.parse(localStorage.getItem('adminDetails'));
    
    
    const getRequest = async (apiName) => {
      const headers = {
        'Content-Type': 'application/json',
        'app-token': process.env.REACT_APP_TOKEN_SECRET,
        Authorization: `Bearer ${TokenDetails.idToken}`,
        
      };
  
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PREFIX}${apiName}`,
          { headers: headers }
        );
  console.log(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PREFIX}${apiName}`)
        const res = response.data;
  
        if (res.code === 200) {
          if(res.data && res.data.length > 0) {
            try {
              const bytes = CryptoJS.AES.decrypt(res.data, process.env.REACT_APP_ADMIN_TOKEN_SECRET);
              const originalText = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
              console.log(originalText)
              return {
                code: res.code,
                status: res.status,
                message: res.message,
                data: originalText,
              };
            } catch (error) {
              console.error("Decryption Error: ", error.message);
              return {
                code: res.code,
                status: "error",
                message: "Error decrypting data",
                data: [],
              };
            }
          } else {
            console.log("Data not found or empty");
            return {
              code: res.code,
              status: res.status,
              message: "Data not found or empty",
              data: [],
            };
          }
        } else if (res.code === 403) {
          navigate("/logout", {
            state: {
              code: 403,
              status: "error",
              message: res.message,
            },
          });
          return null;
        } else {
          return {
              code: res.code,
              status: res.status,
              message: res.message,
              data: [],
          };
        }
      } catch (error) {
        console.error("Error: ", error);
        return {
              code: 401,
              status: 'ERROR',
              message: error.message,
              data: [],
        };
      }
    };


    
    const postRequest = async (apiName, jsonpar) => {
      console.log(jsonpar);
  
      const headers = {
          'Content-Type': 'application/json',
          'app-token': process.env.REACT_APP_TOKEN_SECRET,
          Authorization: `Bearer ${TokenDetails.idToken}`,
      };
  
      try {
          // Encrypt payload
          const encryptedPayload = CryptoJS.AES.encrypt(
              jsonpar,
              process.env.REACT_APP_ADMIN_TOKEN_SECRET
          ).toString();
//   console.log(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PREFIX}${apiName}`,)
          const response = await axios.post(
              `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PREFIX}${apiName}`,
              { data: encryptedPayload },
              { headers }
          );
  
          // Parse the response
          const res = response.data;
          console.log('res', res);
  
          if (res.code === 200) {
              let decryptedData = [];
  
              if (res.data) {
                console.log(res.data)
                  const bytes = CryptoJS.AES.decrypt(
                      res.data,
                      process.env.REACT_APP_ADMIN_TOKEN_SECRET
                  );
                  decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
              }
  
              return {
                  code: res.code,
                  status: res.status,
                  message: res.message,
                  data: decryptedData,
              };
          } else if (res.code === 403) {
              // Unauthorized access, redirect to logout
              navigate("/logout", {
                  state: {
                      code: 403,
                      status: "error",
                      message: res.message,
                  },
              });
              return null; // Early return to avoid further processing
          } else {
              // Handle other response codes
              return {
                  code: res.code,
                  status: res.status,
                  message: res.message,
                  data: [],
              };
          }
      } catch (error) {
          console.error("API Error:", error);
  
          // Handle network or unexpected errors
          return {
              code: 500,
              status: "ERROR",
              message: error.response?.data?.message || "An unexpected error occurred.",
              data: [],
          };
      }
  };
  
  const putRequest = async (apiName, jsonpar) => {
    console.log(jsonpar);

    const headers = {
        'Content-Type': 'application/json',
        'app-token': process.env.REACT_APP_TOKEN_SECRET,
        Authorization: `Bearer ${TokenDetails.idToken}`,
    };

    try {
        // Encrypt payload
        console.log( `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PREFIX}${apiName}`)
        const encryptedPayload = CryptoJS.AES.encrypt(
            jsonpar,
            process.env.REACT_APP_ADMIN_TOKEN_SECRET
        ).toString();
        console.log(encryptedPayload)
        const response = await axios.put(
          `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PREFIX}${apiName}`,
            { data: encryptedPayload },
            { headers }
        );

        // Parse the response
        const res = response.data;
        console.log('res', res);

        if (res.code === 200) {
            let decryptedData = [];

            if (res.data) {
                console.log(res.data);
                const bytes = CryptoJS.AES.decrypt(
                    res.data,
                    process.env.REACT_APP_ADMIN_TOKEN_SECRET
                );
                decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            }

            return {
                code: res.code,
                status: res.status,
                message: res.message,
                data: decryptedData,
            };
        } else if (res.code === 403) {
            // Unauthorized access, redirect to logout
            navigate("/logout", {
                state: {
                    code: 403,
                    status: "error",
                    message: res.message,
                },
            });
            return null; // Early return to avoid further processing
        } else {
            // Handle other response codes
            return {
                code: res.code,
                status: res.status,
                message: res.message,
                data: [],
            };
        }
    } catch (error) {
        console.error("API Error:", error);

        // Handle network or unexpected errors
        return {
            code: 500,
            status: "ERROR",
            message: error.response?.data?.message || "An unexpected error occurred.",
            data: [],
        };
    }
};



const deleteRequest = async (apiName) => {
  

  const headers = {
      'Content-Type': 'application/json',
      'app-token': process.env.REACT_APP_TOKEN_SECRET,
      Authorization: `Bearer ${TokenDetails.idToken}`,
  };

  try {
     const response = await axios.delete(
         `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PREFIX}${apiName}`,
          {
              headers,
          }
      );

      // Parse the response
      const res = response.data;
      console.log('res', res);

      if (res.code === 200) {
          let decryptedData = [];

          if (res.data) {
              console.log(res.data);
              const bytes = CryptoJS.AES.decrypt(
                  res.data,
                  process.env.REACT_APP_ADMIN_TOKEN_SECRET
              );
              decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
          }

          return {
              code: res.code,
              status: res.status,
              message: res.message,
              data: decryptedData,
          };
      } else if (res.code === 403) {
          // Unauthorized access, redirect to logout
          navigate("/logout", {
              state: {
                  code: 403,
                  status: "error",
                  message: res.message,
              },
          });
          return null; // Early return to avoid further processing
      } else {
          // Handle other response codes
          return {
              code: res.code,
              status: res.status,
              message: res.message,
              data: [],
          };
      }
  } catch (error) {
      console.error("API Error:", error);

      // Handle network or unexpected errors
      return {
          code: 500,
          status: "ERROR",
          message: error.response?.data?.message || "An unexpected error occurred.",
          data: [],
      };
  }
};

  // const formData = new FormData();
  // formData.append("id", atob(props.match.params.id));
  // formData.append("file", file);
  // formData.append("fileName", fileName);
  // const res = await postRequestByFormData('api-name', formData);
  // if (res && res.code === 200) {
  //   setData(res.data);
    
  //   setAlertData((AlertData) => ({
  //     ...AlertData,
  //     variant: 'success',
  //     message: res.message,
  //   }));
  // }
  // else {
  //   setAlertData((AlertData) => ({
  //     ...AlertData,
  //     variant: 'error',
  //     message: res.message,
  //   }));
  // }
  // resetAlertData();
  // Above text is an example of below function how to call below function
const postRequestByFormData = async (apiName, formData) => {
    const headers = {
        'Content-Type': 'multipart/form-data; boundary=<calculated when request is sent>',
        // 'Content-Length': '<calculated when request is sent>',
        'app-token': process.env.REACT_APP_TOKEN_SECRET,
        'Authorization':`Bearer ${TokenDetails.idToken}`,
        
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PREFIX}${apiName}`,
        formData,
        { headers: headers }
      );

      const res = response.data;

      if (res.code === 200) {
        if(res.data) {
            const bytes = CryptoJS.AES.decrypt(res.data, process.env.REACT_APP_ADMIN_TOKEN_SECRET);
            const originalText = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

            return {
                code: res.code,
                status: res.status,
                message: res.message,
                data: originalText,
            };
        }
        else {
            return {
                code: res.code,
                status: res.status,
                message: res.message,
                data: [],
            };
        }
      } else if (res.code === 403) {
        navigate('/logout', { code: 401, status: 'error', message: res.message });
      } else {
        return {
            code: res.code,
            status: res.status,
            message: res.message,
            data: [],
        };
      }
    } catch (error) {
      console.error("Error: ", error);
      return {
            code: 401,
            status: 'ERROR',
            message: error.message,
            data: [],
      };
    }
  };

  return { getRequest , postRequest , putRequest, deleteRequest, postRequestByFormData};
};

export default useRequests;